/**
 * Raw typography tokens (Font Facts)
 * Extracted from the provided baseline typography scale.
 */

export const fontSizes = {
  display: {
    large: 64,
    medium: 48,
    small: 36,
  },
  headline: {
    large: 32,
    medium: 28,
    small: 24,
  },
  title: {
    large: 22,
    medium: 16,
    small: 14,
  },
  label: {
    large: 14,
    medium: 12,
    small: 11,
  },
  body: {
    large: 16,
    medium: 14,
    small: 12,
  },
} as const;

export const lineHeights = {
  display: {
    large: 64,
    medium: 72,
    small: 54,
  },
  headline: {
    large: 48,
    medium: 42,
    small: 30,
  },
  title: {
    large: 28,
    medium: 24,
    small: 20,
  },
  label: {
    large: 20,
    medium: 16,
    small: 16,
  },
  body: {
    large: 24,
    medium: 20,
    small: 16,
  },
} as const;

export const fontWeights = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
} as const;

export const letterSpacings = {
  none: 0,
  tight: -0.25,
  normal: 0,
  wide: 0.1,
  wider: 0.15,
  widest: 0.25,
  extraWide: 0.5,
  relaxed: 0.4,
} as const;

export const fontFamilies = {
  default: "Poppins",
} as const;
